import { useTranslation } from "react-i18next";
import { Typography, Box } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import styles from "./BlogTabBar.module.scss";

import { Author, ShareButton } from "../../../../library/common";

const BlogTopBar = ({
  title = "",
  publishedDate = "",
  authors = [],
  path = "blog",
  locationLink = "",
  district = "",
  state = "",
  address = "",
  country = "",
  pincode = "",
  metaTitle = "",
  metaDescription = "",
}) => {
  const {
    i18n: { language },
  } = useTranslation();
  return (
    <div className={styles.blogHeadingContainer}>
      <div className={styles.titleAndShare}>
        <Typography variant="h1" component="h1">
          {title?.[language] ? title?.[language] : ""}
        </Typography>
        <ShareButton title={metaTitle} description={metaDescription} />
      </div>
      {path === "blog" ? (
        <Author author={authors?.[0]} publishedDate={publishedDate} />
      ) : (
        <Box
          display="flex"
          alignItems="center"
          sx={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            if (locationLink) {
              window.open(locationLink, "_blank");
            }
          }}
        >
          <LocationOnIcon fontSize="small" color="action" sx={{ mr: 1 }} />
          <Typography variant="body2">
            {address ? `${address?.[language]}, ` : ""}
            {district ? `${district?.[language]}, ` : ""}
            {state ? `${state?.[language]}, ` : ""}
            {country ? `${country?.[language]}, ` : ""}
            {pincode}
          </Typography>
        </Box>
      )}
    </div>
  );
};
export default BlogTopBar;
